const APIKEY = 'AIzaSyAKDOs_NJSEF0btECNZqCep9AiPtO1iozI';

export interface YoutubeInfo {
  items: Array<{
    id?: string;
    snippet: {
      title: string;
      channelTitle: string;
    };
  }>;
}

export class YoutubeService {
  static getIdFromYoutubeUrl = (url: string | null | undefined) => {
    if (!url) {
      return undefined;
    }
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|\?v=)([^#&?]*).*/;
    const match = url.match(regExp);
    if (match && match.length >= 3) return match[2];
    return undefined;
  };

  static getVideoInfo(yotubeUrl: string) {
    const videoId = YoutubeService.getIdFromYoutubeUrl(yotubeUrl);
    return fetch(
      `https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails&id=${videoId}&key=${APIKEY}`,
      { method: 'GET' },
    ).then((res) => res?.json() as Promise<YoutubeInfo>);
  }
}
